// extracted by mini-css-extract-plugin
module.exports = {"tpSlider":"TrustpilotWidgetSlider_tpSlider__h5MpV"};